import React, { Component } from "react";
import axios from "axios";
import { authService } from "../../../auth";
import EntityRestrictedPopUp from "./EntityRestrictedPopUp";
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ReactTooltip from "react-tooltip";

const ErorrMsgPopUp = withReactContent(alertPopUp)

const allowRestrictRemoveMsg = (actiionType) => {
    return ({
        title: `Are you sure you want to ${actiionType === "ALLOWED" ? "allow" : actiionType === "NOT_ALLOWED" ? "restrict" : "remove"} this user ?`,
        focusConfirm: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        cancelButtonText: 'Ignore',
        allowOutsideClick: false,
    })
}
class AllowRestrictRemoveBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            entityRestrictedPopFlag: false,
            restrictedUserData: {}
        }
    }

    onClickActionBtn = (data, actionType) => {
        if(!data.postingRestricted && this.props.donationEntityConfig?.currentPlan === "BRONZE" && actionType !== "REMOVE") {
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>Please upgrade your WeNaturalists Pro subscription to use “Restrict Posting” feature.</p><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a></>,
                })
            })
        } else {
            const confirmPopUp = async () => {
                const swalval = await ErorrMsgPopUp.fire(allowRestrictRemoveMsg(actionType));
                if (swalval && swalval.value === true) {
                    if(actionType === "REMOVE") {
                        this.removeRestrictedParticipants(data);
                    } else {
                        this.allowRestrictPosting(data);
                    }
                }
            };
            confirmPopUp();
        }
    }

    allowRestrictPosting = (data) => {
        let postData = {
            userId: data.userId,
            restrictionRequestingUserId: this.state.userData.userId,
            entityId: data.projectId ? data.projectId : this.props.entityId,
            entityType: "PROJECT",
            restrictionType: "POSTING",
            restrictedPermissionType: data.postingRestricted ? "ALLOWED" : "NOT_ALLOWED"
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/backend/entity/restriction/create`,
            headers: { 'Content-Type': 'application/json' },
            data: postData,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.props.onSuccessAllowRestrictPosting(data, "ALLOW_RESTRICT");
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    removeRestrictedParticipants = (data) => {
        let postData = {
            userId: data.userId,
            requestingUserId: this.state.userData.userId,
            projectId: data.projectId ? data.projectId : this.props.entityId,
            participationType: this.props.activeTab
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/backend/participation/delete`,
            headers: { 'Content-Type': 'application/json' },
            data: postData,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.props.onSuccessAllowRestrictPosting(data, "REMOVE");
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    onClickHistoryData = (data) => {
        data.entityType = "PROJECT";
        data.projectId = data.projectId ? data.projectId : this.props.entityId;
        data.participationType = this.props.activeTab;
        this.setState({
            restrictedUserData: data,
            entityRestrictedPopFlag: true
        }, () => {
            window.$("#entityRestrictedPopUp").modal("show");
        })
    }

    onCloseRestrictionPopUp = () => {
        window.$("#entityRestrictedPopUp").modal("hide");
        this.setState({
            restrictedUserData: {},
            entityRestrictedPopFlag: false
        })
    }

    render() {
        const { userDetails, activeTab } = this.props;
        const { entityRestrictedPopFlag, restrictedUserData } = this.state;
        return (
            <>
                {userDetails.postingRestrictionPermission && 
                    <>
                    {userDetails.postingRestricted && (activeTab !== "GUEST_INVITEE" || (activeTab === "GUEST_INVITEE" && userDetails.status === "ACCEPTED")) &&
                        <>
                            <span style={{margin: '0 5px'}}>
                                <i className="ideactivated" data-tip="msg to show" data-for={"restricted"} data-place='top' style={{color: 'red'}} />
                            </span>
                            <ReactTooltip
                                className="rtoolTip"
                                place="bottom"
                                id={"restricted"}
                                type="dark"
                                textColor="#00394D"
                                effect="solid"
                                backgroundColor="#ffffff">Posting Restricted</ReactTooltip>
                        </>
                    }

                    <div className="contxmenu">
                        <button type="button" className="btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="iKebab" />
                        </button>
                        <div className="dropdown-menu fadeIn animated">
                            <a className="dropdown-item" href="javascript:void(0)" onClick={(e) => this.onClickHistoryData(userDetails)}>
                                <i className={"iEdition2"} /> History
                            </a>
                            {(activeTab !== "GUEST_INVITEE" || (activeTab === "GUEST_INVITEE" && userDetails.status === "ACCEPTED")) &&
                                <>
                                    {((activeTab !== "GUEST_INVITEE" && this.props.projectType !== "JOB") || activeTab === "GUEST_INVITEE") && 
                                        <a className="dropdown-item" href="javascript:void(0)" onClick={(e) => this.onClickActionBtn(userDetails, userDetails.postingRestricted ? "ALLOWED" : "NOT_ALLOWED")}>
                                            <i className={userDetails.postingRestricted ? "iReactivate" : "ideactivated"} /> {userDetails.postingRestricted ? "Allow Posting" : "Restrict Posting"}
                                        </a>
                                    }
                                    {this.props.projectType !== "FUNDRAISE" && 
                                        <a className="dropdown-item" href="javascript:void(0)" onClick={(e) => this.onClickActionBtn(userDetails, "REMOVE")}>
                                            <i className="iRemoveUser" /> Remove
                                        </a>
                                    }
                                </>
                            }
                        </div>                        
                    </div>
                    </>
                }
                {entityRestrictedPopFlag && <EntityRestrictedPopUp entityRestrictedData={restrictedUserData} onCloseRestrictionPopUp={this.onCloseRestrictionPopUp} />}
            </>
        )
    }
}

export default AllowRestrictRemoveBtn;